<template>
	<div>
		<modalFreeTools ref="modalFreeTools" v-model="dialog" :val="val" :propAdd="propAdd" @action="saveData"/>
		<modalconfirm ref="confirmFreeTools" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Free Tools</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn light depressed class="primary" @click="tambah()">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Free Tools</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="freeToolsResult" :options.sync="option" :server-items-length="freeToolsPagination.total_data" hide-default-footer>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="ubah(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="hapus(item.free_tools_id, item.product_name)" class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!freeToolsPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="freeToolsPagination">
			<v-row>
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="freeToolsPagination.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" @input="changeLimit" label="Item" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import modalFreeTools from '@/views/MLwarehouse/product/ModalFreeTools'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modalFreeTools
	},
	data() {
		return {
			page: 1,
			limit: "10",
			listLimit: [ '10', '10', '20', '50', '100' ],
			val: {},
			dialog: false,
			dialogConfirm: false,
			propAdd: '',
			dropfilter: false,
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name'},
			{ text: 'Kode Produk', value: 'product_code'},
			{ text: 'Jumlah', value: 'quantity', align: 'end'},
			{ text: 'Aksi', value: 'action', sortable: false },
			],
			filterData: [{
				type: 'text',
				label: 'Nama Produk',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_name'
				}
			}, {
				type: 'text',
				label: 'Kode Produk',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_code'
				}
			}],
			params: [],
		}
	},
	computed: {
		...mapState('freeTools', ['freeToolsResult', 'product', 'freeToolsPagination', 'konfirmResponse', 'responSukses']),
	},
	methods: {
		...mapActions('freeTools', ['getFreeTools', 'deleteFreeTools', 'addFreeTools', 'updateFreeTools', 'exportFreeTools', 'optionProduct']),
		...mapMutations('freeTools', ['konfirmasiSukses']),
		...mapMutations('freeTools', ['clearDataFreeTools']),
		...mapMutations(['setOverlay', 'setFilter']),

		getData(){
			this.getFreeTools(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		exportData(){
			this.exportFreeTools(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		hapus(id, name){
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name} dari Free Tools`
			this.$refs.confirmFreeTools.setMessage(msg)
			this.$refs.confirmFreeTools.showConfirm()
		},
		tambah (){
			this.propAdd = "add";
			this.dialog = true;
			this.val = {
				product_id: '',
				quantity: '',
			};
		},
		ubah(item) {
			this.propAdd = "edit";
			this.val = item;
			this.dialog = true;
		},
		async deleteData () {
			await this.setOverlay(true)
			await this.$refs.confirmFreeTools.hideConfirm()
			await this.deleteFreeTools({
				id: this.propDelete
			}).then( () => {
				if(this.responSukses.code == 200) {
					this.getData()
					this.propDelete = ''
				}
			})
			await this.setOverlay(false)
		},
		async saveData (value) {
			this.setOverlay(true)
			if (this.propAdd == 'add') {
				await this.addFreeTools(value).then( () => {
					if(this.responSukses.code == 200) {
						this.reset()
					}
				})
			} else if (this.propAdd == 'edit') {
				let params = {
					id: value.free_tools_id,
					product_id: value.product_id,
					quantity: value.quantity,
				}
				await this.updateFreeTools(params).then( () => {
					if(this.responSukses.code == 200) {
						this.reset()
					}
				})
			}
			this.setOverlay(false)
		},
		reset() {
			this.getData()
			this.dialog = false
			this.val = {}
			this.konfirmasiSukses('')
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
	},
	created() {
		this.setFilter(this.filterData)
		this.$store.dispatch('setPageTitle', `Free Tools`)
		this.getData()
		this.optionProduct()
	},
	beforeDestroy() {
		this.clearDataFreeTools()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
</style>